/* eslint-disable no-template-curly-in-string */

export const CONFIRMATION_MESSAGE_APPEAL =
  'Укажите код ${code} для подтверждения адреса электронной почты на сайте RGS.ru, чтобы отправить обращение.\n\nСрок действия кода — 5 минут.'
export const CONFIRMATION_MESSAGE_MARKETING_INTEGRATIONS =
  'Укажите код ${code} для подтверждения адреса электронной почты на сайте RGS.ru, чтобы подписаться на информационные рассылки.\n\nСрок действия кода — 5 минут.'

export const validateOnBlurInputFieldTypes = [
  'InputText',
  'InputTextArea',
  'InputSelect',
  // 'InputDate',
  'BlockSelectAuto',
]
